import React, { useState, useEffect } from "react";
import { Fragment } from "react";
import Button from "../../Resources/Forms/Button";
import "../../Styles/Pages/firsttimeorder.scss";
import dayjs from "dayjs";
import CallAgentVerification from "./CallAgentVerification";
import {
	_cloneObject,
	_formatCurrency,
	_capitalizeText,
} from "../../Utils/helpers";
import { GET } from "../../Utils/api";
import Loading from "../../Loaders/Loading";

const OrderProcessingDetails = props => {
	const [isCallAgentVerification, setCallAgentVerification] = useState(false);
	const [showLoading, setShowLoading] = useState(true);
	const [orderDetailRetail, setOrderDetailRetail] = useState({
		OnlineOrder: [],
	});

	useEffect(() => {
		getOrder_Details();
	}, []);
	const getOrder_Details = async () => {
		let header = _cloneObject(props.context.jsonHeader);
		const resp = await GET(
			`Store/GetOnlineOrders_Retail_details?Orderid=${props.orderDetails.Orderid}`,
			header,
		);
		if (!resp.error) {
			try {
				setShowLoading(false);
				setOrderDetailRetail(resp);
			} catch (err) {
				setShowLoading(false);
				console.log(err);
			}
		}
	};
	return (
		<Fragment>
			{showLoading ? (
				<Loading size={"4px"} margin={"80px auto 150px"} />
			) : (
				<div>
					{isCallAgentVerification ? (
						<CallAgentVerification
							orderDetails={props.orderDetails}
							orderDetailRetail={orderDetailRetail}
							setFirstTimeOrder={props.setFirstTimeOrder}
							context={props.context}
							setShowImageTagging={props.setShowImageTagging}
							imageTagData={props.imageTagData}
						/>
					) : (
						<div className="customer__location">
							<div className="customer__location__header">
								<div className="customer__location__header__flex__between">
									<span
										className={`${props.orderDetails.OrderStatus.toLowerCase()}`}
									>
										{props.orderDetails.OrderStatus}
									</span>
									{/* <div className="customer__location__header__await">
									Awaiting Confirmation
					</div> */}
									<div className="customer__location__header__first__order">
										First Order
									</div>
								</div>
								<div className="customer__location__header__data">
									<div style={{ flexGrow: 1 }}>
										<div className="customer__location__header__name">
											{props.orderDetails.CustomerName}
										</div>
										<div className="customer__location__header__order__id">
											Order #{props.orderDetails.Orderid}
										</div>
										<div className="customer__location__header__date">
											Order date:{" "}
											{dayjs(props.orderDetails.Createddate).format(
												`MMM D, YYYY.${
													window.screen.width > 350 ? "h:mm a" : ""
												}`,
											)}{" "}
										</div>
									</div>
									<div className="flex" style={{ alignItems: "flex-end" }}>
										{props.orderDetails.CustomerPhone && (
											<div
												className="invoice-details-body-project-user-contact flex align-center"
												onClick={() =>
													(window.location.href = `tel:${props.orderDetails.CustomerPhone}`)
												}
											>
												<img
													src="Images/dark-call.svg"
													width="24px"
													height="30px"
													alt="call"
												/>
											</div>
										)}
										<span
											onClick={() =>
												window.open(
													`https://api.whatsapp.com/send?phone=234${props.orderDetails.CustomerPhone.substring(
														1,
														11,
													)}`,
													"_blank",
												)
											}
										>
											<img
												src="Images/whatsapp-icon.svg"
												width="25px"
												height="25px"
												alt="whatsapp"
											/>
										</span>
										{/* <img
											src="Images/downloadicon.png"
											width="36px"
											height="36px"
											alt="download"
										/> */}
									</div>
								</div>
							</div>
							<div className="customer__location__body">
								<div className="customer__location__body__box__order">
									<div className="customer__location__body__box__order__label">
										Order
									</div>

									{orderDetailRetail.OnlineOrder.length ? (
										<div className="payment-history">
											{orderDetailRetail.OnlineOrder.map((Item, index) => (
												<div
													className="customer__location__body__box__order__item"
													key={index}
												>
													<div className="customer__location__body__box__order__item__flex">
														<div className="customer__location__body__box__order__item__flex__order">
															<div className="customer__location__body__box__order__item__flex__name">
																{_capitalizeText(Item.ItemName || "")}
															</div>
															<div className="flex flex-between align-center">
																<div className="customer__location__body__box__order__item__flex__label">
																	Quantity: <span> {Item.Quantity}</span>
																</div>
																<div className="customer__location__body__box__order__item__flex__label">
																	Price:{" "}
																	<span>{_formatCurrency(Item.Price)}</span>
																</div>
															</div>
														</div>
													</div>
												</div>
											))}
										</div>
									) : null}
									<div
										className="flex flex-between align-center"
										style={{ marginTop: "10px" }}
									>
										<div className="customer__location__body__box__order__total">
											Total :
										</div>
										<div className="customer__location__body__box__order__total">
											{_formatCurrency(props.orderDetails.TotalPrice)}
										</div>
									</div>
								</div>
								<div className="customer__location__body__box__order">
									<div className="customer__location__body__box__order__label">
										Payment Information
									</div>
									<div className="customer__location__body__box__order__item">
										<div className="customer__location__body__box__order__item__flex">
											<div>
												<div className="customer__location__body__box__order__item__flex__name">
													Payment Mode
												</div>
												<div className="customer__location__body__box__order__item__flex__label">
													{props.orderDetails.OrderPaymentStatus &&
													props.orderDetails.OrderPaymentStatus.toLowerCase() ===
														"prepaid"
														? "Prepaid"
														: "COD"}
												</div>
											</div>
										</div>
										<div className="customer__location__body__box__order__item__flex">
											<div>
												<div className="customer__location__body__box__order__item__flex__name">
													Payment Details
												</div>
												<div>
													<div className="customer__location__body__box__order__item__flex__label">
														Total Price:{" "}
														<span>
															{_formatCurrency(props.orderDetails.TotalPrice)}
														</span>
													</div>
													{props.orderDetails.DeliveryAmount > 0 ? (
														<div className="customer__location__body__box__order__item__flex__label">
															Shipping Fee:{" "}
															<span>
																{_formatCurrency(
																	props.orderDetails.DeliveryAmount,
																)}
															</span>
														</div>
													) : null}
												</div>
											</div>
										</div>
									</div>
									{props.orderDetails.OrderLocation && (
										<div className="customer__location__body__box__order">
											<div className="customer__location__body__box__order__label">
												Delivery Information{" "}
											</div>
											<div
												className="customer__location__body__box__order__item"
												style={{ paddingBottom: "30px" }}
											>
												<div className="customer__location__body__box__order__item__shipping">
													<div className="customer__location__body__box__order__item__shipping__label">
														Shipping Address{" "}
													</div>
													<div className="customer__location__body__box__order__item__shipping__address">
														{props.orderDetails.OrderLocation}
													</div>
												</div>
											</div>
										</div>
									)}
								</div>
							</div>
							<div className="modal-submit">
								<Button
									type={"primary"}
									text={"Proceed to Verification"}
									onClick={() => setCallAgentVerification(true)}
								/>
							</div>
						</div>
					)}
				</div>
			)}
		</Fragment>
	);
};

export default OrderProcessingDetails;
